export default __webpack_public_path__ + "static/newsletter-img@3x-c8a29d51217d5f9a40f8d9a1106f0b53.png";